import React ,{useState,useRef}from 'react'
import Userdashboardheader from './userdashboardheader/Userdashboardheader'
import {MdOutlineContentCopy,MdOutlineDone} from 'react-icons/md'
import {BsImageFill} from 'react-icons/bs'
import {BsUpload} from 'react-icons/bs'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import {FiLink} from 'react-icons/fi'
import {AiOutlineArrowLeft} from 'react-icons/ai'
import Loader from './Loader'
import axios from 'axios'

const Deposit = ({amount,active,close,route}) => {
    const navigate= useNavigate()
    const [Active] = useState(active)
    const [clipBoard, setClipBoard] = useState(false)
    const [showImage,setShowImage] = useState()
    const clipRef = useRef(null)
    const [modal,setModal] = useState(false)
    const [loader,setLoader] = useState(false)
    const [transactionId, setTransactionId] = useState(null)

    // copy to clipboard function starts here 
    const copy = ()=>{
        navigator.clipboard.writeText(clipRef.current.value)
    }

    // upload proof image code starts here 

    const uploadProof = async (file)=>{
        setModal(true)
        console.log(file)
        const formData = new FormData()
        formData.append('file',file)
        formData.append('upload_preset','upload');
        const req = await fetch('https://api.cloudinary.com/v1_1/duesyx3zu/image/upload',
          {
          method:'POST',
          body:formData,
        }
        )
        const res = await req.json()
        if(res){
            setShowImage(res.secure_url)
            setModal(false)
        }
    }
    
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

    // send proof function starts here 

    const sendProof = async () => {
      try {
        setLoader(true);
        const token = localStorage.getItem('token');
        
        if (!transactionId) {
          // First create the deposit request
          const depositResponse = await axios.post(
            `${route}/ledger/fund`,
            {
              amount: amount,
              method: Active.method
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'x-access-token': token
              }
            }
          );

          if (depositResponse.data.status === 'ok') {
            setTransactionId(depositResponse.data.fundRequest._id);
            
            // Then upload the proof
            const proofResponse = await axios.post(
              `${route}/ledger/proof`,
              {
                transactionId: depositResponse.data.fundRequest._id,
                proofImage: showImage
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'x-access-token': token
                }
              }
            );

            if (proofResponse.data.status === 'ok') {
              Toast.fire({
                icon: 'success',
                title: proofResponse.data.message
              });
              setTimeout(() => navigate('/dashboard'), 2000);
            }
          }
        } else {
          // If we already have a transaction ID, just upload the proof
          const proofResponse = await axios.post(
            `${route}/ledger/proof`,
            {
              transactionId: transactionId,
              proofImage: showImage
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'x-access-token': token
              }
            }
          );

          if (proofResponse.data.status === 'ok') {
            Toast.fire({
              icon: 'success',
              title: proofResponse.data.message
            });
            setTimeout(() => navigate('/dashboard'), 2000);
          }
        }
      } catch (error) {
        console.error('Error:', error);
        Toast.fire({
          icon: 'error',
          title: error.response?.data?.message || 'Failed to submit deposit request'
        });
      } finally {
        setLoader(false);
      }
    };
        
  return (
    <div>
        {
        loader && 
          <Loader />
      }
        <Userdashboardheader route={route}/>
        <div className="checkout-page">
                <div className="floating-btn" onClick={()=>{
                    close()
                }}>
                    <AiOutlineArrowLeft />
                </div>
                <h3>Deposit Confirmation</h3>
                <p>Please complete your deposit by following these steps</p>
            <div className="checkout-info-container">
                <p>You are depositing <span className='bold'>${amount ? amount.toFixed(2) : '0.00'} USD</span></p>
                <h3>Please send payment to the following {Active.method} address:</h3>
                <div className="click-to-copy-container">
                    <span className='clipboard-btn'>
                       <FiLink />
                    </span>
                    <input type="text" value={Active.wallet} ref={clipRef}/>
                    <span 
                        className="clipboard-btn" 
                        onClick={() => {
                            copy();
                            setClipBoard(true);
                            setTimeout(() => setClipBoard(false), 2000);
                        }}
                    >
                        {clipBoard ? <MdOutlineDone /> : <MdOutlineContentCopy />}
                    </span>
                </div>
                <div className="proof-container">
                    <form className='proof-form' onSubmit={(e)=>{
                        e.preventDefault()
                        sendProof()
                    }}>
                        <p>Upload proof of payment</p>
                          <div className="proof-img-container">
                              {
                                  modal && <div className="ping-container"><div className="ping"></div></div> 
                              }
                            {
                                showImage === undefined &&  !modal ? <BsImageFill /> : <img src={`${showImage}`} alt="Payment proof" className='proof-image'/> 
                            }
                        </div>
                        <label htmlFor="proof-img" className='proof-label'>
                            <BsUpload />
                            <input type="file" accept='.jpg,.png,.jpeg' name="proof" id="proof-img" className='proof-input' required onChange={(e)=>{
                                 const image = e.target.files[0]
                                 uploadProof(image)
                            }} />
                        </label>
                        <input type="submit" value="Submit Proof" className='proof-submit-btn' disabled={!showImage || modal} />
                    </form>
                </div>  
            </div>
        </div>
    </div>
  )
}

export default Deposit